import { jsx } from "panel";
import { selx } from "clsx";
import { formatMetricNumberWithUnits } from "common/util";
import { LENGTH, SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { LIFT_TOOLTIP_COMPARE } from "common/report/util/lift/types";
import { formatLiftPercent } from "common/report/util/lift";
import { getFinalDisplayOptions, getMetricFormattingDefaultsFromShowClause } from "common/report/insights/charts/util";
import { eventPropertyDefinitionsStore } from "common/report/stores/property-definitions";
export function getDataCellRenderer(hasLift, bookmarkController, metricsResource, metricKeyToShowClauseMap) {
  return function({ item, context }) {
    const cellIndex = parseInt(context.field, 10);
    const cell = item.cells.length > cellIndex ? item.cells[cellIndex] : null;
    if (cell) {
      const showClause = bookmarkController.getShowClauseFromRetentionTableRow(item, metricKeyToShowClauseMap);
      const isPct = bookmarkController.isPercentageView(item.matchingShowClauseIndex);
      const inputValue = isPct ? cell.percent * 100 : cell.value;
      const formatValue = (value) => {
        return formatMetricNumberWithUnits(
          value,
          getFinalDisplayOptions(
            showClause,
            eventPropertyDefinitionsStore,
            metricsResource,
            getMetricFormattingDefaultsFromShowClause(showClause)
          )
        );
      };
      const mainDisplayValue = formatValue(inputValue);
      const coreCellContent = `${mainDisplayValue}${cell.incomplete ? `*` : ``}`;
      if (hasLift) {
        const liftField = item[context.liftField];
        const liftExtra = item[context.liftExtra];
        const isPositive = liftField > 0;
        const tooltipBaselineDisplayValue = formatValue(liftExtra);
        return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: selx(`mp-table-cell`) }, coreCellContent, /* @__PURE__ */ jsx(
          TextHighlightEl,
          {
            sel: ".mp-lift-pill",
            attrs: {
              text: formatLiftPercent(liftField),
              theme: isPositive ? TEXT_HIGHLIGHT_THEME.POSITIVE : TEXT_HIGHLIGHT_THEME.NEGATIVE,
              size: SIZE.SMALL,
              length: LENGTH.THIN
            }
          }
        ), /* @__PURE__ */ jsx(
          TooltipEl,
          {
            attrs: {
              placement: Placement.Top,
              text: `${mainDisplayValue} ${LIFT_TOOLTIP_COMPARE} ${tooltipBaselineDisplayValue}`
            }
          }
        )));
      }
      return coreCellContent;
    }
    return void 0;
  };
}
